import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const MinimalV2 = ({ children }) => (
  <Box component="main" sx={{ minHeight: '100vh' }}>{children}</Box>
);

MinimalV2.propTypes = {
  children: PropTypes.node,
};

export default MinimalV2;
